import user_management_route from "./modules/user_management_route";
import role_management_route from "./modules/role_management_route";
import my_profile_route from "./modules/my_profile_route";
import dashboard_route from "./modules/dashboard_route";
import customer_management_route from "./modules/customer_management_route";
import retailer_management_route from "./modules/retailer_management_route";
import credit_package_route from "./modules/credit_package_route";
import card_management_route from "./modules/card_management_route";
import product_management_route from "./modules/product_management_route";
import redemption_product_route from "./modules/redemption_product_route";
import treasure_box_route from "./modules/treasure_box_route";
import treasure_box_plays_route from "./modules/treasure_box_plays_route";
import bank_transfer_route from "./modules/bank_transfer_route";
import order_management_route from "./modules/order_management_route";
import redemption_order_route from "./modules/redemption_order_route";
import campaign_prizes_route from "./modules/campaign_prizes_route";
import customer_campaigns_route from "./modules/customer_campaigns_route";
import campaign_prize_orders_route from "./modules/campaign_prize_orders_route";
import transaction_history_route from "./modules/transaction_history_route";
import prize_distribution_rules_route from "./modules/prize_distribution_rules_route";
import treasure_box_settings_route from "./modules/treasure_box_settings_route";
import big_prize_assignments_route from "./modules/big_prize_assignments_route";
import referral_settings_route from "./modules/referral_settings_route";
import referral_management_route from "./modules/referral_management_route";
import stock_settings_route from "./modules/stock_settings_route";
import support_tickets_route from "./modules/support_tickets_route";

import { PERMISSION } from "src/utils/constant_permission";

/* Tag every route in a module with the permission needed to open it.
   Tagging here rather than inside the 24 module files puts the whole access map
   on one screen you can read top to bottom -- and a module added later that
   nobody tags is visible immediately, instead of being a silently-open route
   buried in file 25.

   The route object spreads LAST so a module needing per-entry permissions can
   override the file-level tag. */
const withPerm = (perm, moduleRoutes) => moduleRoutes.map((route) => ({ perm, ...route }));

const routes = [
    // Untagged: every staff role must be able to land somewhere and open their
    // own profile, whatever else their role withholds.
    ...dashboard_route,
    ...my_profile_route,

    ...withPerm(PERMISSION.USERS_VIEW, user_management_route),
    ...withPerm(PERMISSION.ROLES_VIEW, role_management_route),
    ...withPerm(PERMISSION.CUSTOMERS_VIEW, customer_management_route),
    ...withPerm(PERMISSION.RETAILERS_VIEW, retailer_management_route),
    ...withPerm(PERMISSION.CARDS_VIEW, credit_package_route),
    ...withPerm(PERMISSION.CARDS_VIEW, card_management_route),
    ...withPerm(PERMISSION.PRODUCTS_VIEW, product_management_route),
    ...withPerm(PERMISSION.REDEMPTION_PRODUCTS_VIEW, redemption_product_route),
    ...withPerm(PERMISSION.STOCK_SETTINGS_MANAGE, stock_settings_route),
    // .view opens both screens; the thread page checks .reply and .manage itself,
    // because those decide what is on the page rather than whether it opens.
    ...withPerm(PERMISSION.SUPPORT_TICKETS_VIEW, support_tickets_route),
    ...withPerm(PERMISSION.MYSTERY_BOX_VIEW, treasure_box_route),
    // Play History and Mystery Draw Orders are the same screen reached two ways;
    // the module file tags them individually.
    ...treasure_box_plays_route,
    ...withPerm(PERMISSION.MYSTERY_BOX_SETTINGS, prize_distribution_rules_route),
    ...withPerm(PERMISSION.MYSTERY_BOX_SETTINGS, treasure_box_settings_route),
    ...withPerm(PERMISSION.CAMPAIGNS_VIEW, big_prize_assignments_route),
    ...withPerm(PERMISSION.CAMPAIGNS_VIEW, customer_campaigns_route),
    ...withPerm(PERMISSION.CAMPAIGNS_VIEW, campaign_prizes_route),
    ...withPerm(PERMISSION.CAMPAIGNS_VIEW, campaign_prize_orders_route),
    ...withPerm(PERMISSION.ORDERS_VIEW, order_management_route),
    ...withPerm(PERMISSION.REDEMPTION_ORDERS_VIEW, redemption_order_route),
    ...withPerm(PERMISSION.TRANSACTIONS_VIEW, transaction_history_route),
    ...withPerm(PERMISSION.TRANSACTIONS_VIEW, bank_transfer_route),
    ...withPerm(PERMISSION.REFERRALS_VIEW, referral_management_route),
    ...withPerm(PERMISSION.REFERRAL_SETTINGS_MANAGE, referral_settings_route),
];

export default routes;
